export default __webpack_public_path__ + "static/media/02.aff2ec83.png";